<a
    class="header__logo header-logo"
    [href]="headerViewService.logoUrl || pathToRootLocalHomePage"
    [title]="brandTitle"
    data-application="header-logo"
>
    @if (isDarkTheme()) {
        @if (headerViewService.logoDark) {
            <website-image
                [src]="headerViewService.logoDark"
                [alt]="headerViewService.logoDarkAlt || DEFAULT_LOGO_ALT"
                class="header-logo__image header-logo__image--dark"
                [config]="imageConfig"
                [width]="124"
                [height]="60"
                [loading]="'eager'"
            ></website-image>
        } @else {
            @if (isWrike) {
                <website-wrike-logo
                    [isDarkTheme]="isDarkTheme()"
                    [attr.aria-label]="DEFAULT_LOGO_ALT"
                    role="img"
                ></website-wrike-logo>
            } @else if (isKlaxoon) {
                <website-klaxoon-logo
                    [isDarkTheme]="isDarkTheme()"
                    [attr.aria-label]="DEFAULT_LOGO_ALT"
                    role="img"
                ></website-klaxoon-logo>
            }
        }
    } @else {
        @if (headerViewService.logoLight) {
            <website-image
                [src]="headerViewService.logoLight"
                [alt]="headerViewService.logoLightAlt || DEFAULT_LOGO_ALT"
                class="header-logo__image header-logo__image--light"
                [config]="imageConfig"
                [width]="124"
                [height]="60"
                [loading]="'eager'"
            ></website-image>
        } @else {
            @if (isWrike) {
                <website-wrike-logo
                    [isDarkTheme]="isDarkTheme()"
                    [attr.aria-label]="DEFAULT_LOGO_ALT"
                    role="img"
                ></website-wrike-logo>
            } @else if (isKlaxoon) {
                <website-klaxoon-logo
                    [isDarkTheme]="isDarkTheme()"
                    [attr.aria-label]="DEFAULT_LOGO_ALT"
                    role="img"
                ></website-klaxoon-logo>
            }
        }
    }
</a>
